module.exports = __webpack_public_path__ + "static/media/aria.f8d563ae.png";